
import { CooksyLogo } from "@/components/CooksyLogo";
import { VerificationProgress } from "./VerificationProgress";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { ChevronLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { useIsMobile } from "@/hooks/use-mobile";

interface VerificationLayoutProps {
  children: React.ReactNode;
  currentStep: number;
  totalSteps: number;
  showBackButton?: boolean;
}

export const VerificationLayout = ({ 
  children, 
  currentStep, 
  totalSteps,
  showBackButton = true 
}: VerificationLayoutProps) => {
  const navigate = useNavigate();
  const isMobile = useIsMobile();

  const handleBack = () => {
    if (currentStep === 1) {
      navigate('/seller/become-cook');
    } else if (currentStep === 2) {
      navigate('/seller/verification/profile');
    } else if (currentStep === 3) {
      navigate('/seller/verification/documents');
    }
  };

  return (
    <div className="min-h-screen bg-background pb-8">
      <main className="container mx-auto px-4 py-8">
        <Card className="max-w-2xl mx-auto p-6">
          {showBackButton && currentStep > 0 && (
            <Button
              variant="ghost"
              className="mb-4"
              onClick={handleBack}
            >
              <ChevronLeft className="h-4 w-4 mr-2" />
              Back
            </Button>
          )}
          <div className="mb-8">
            <VerificationProgress currentStep={currentStep} totalSteps={totalSteps} />
          </div>
          {children}
        </Card>
      </main>
    </div>
  );
};
